"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./NumberField.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * NumberFields allow users to input numbers into a UI.
 *
 * It expects a minimum and maximum value to be provided, which will be visually
 * rendered to communicate these restrictions to the user.
 *
 * It is built on top of the InputField component, and accepts all of the
 * InputField's props, although the `as` value of the `Input` is set to
 * `NumberInput`, and cannot be changed.
 *
 * Note that, per the `NumberFormat` component, the `onChange` event returns the
 * formatted string value used in the input, while `onValueChange` returns an
 * object containing both the raw numeric value, as well as the formatted
 * string. Use the correct handler for your purposes accordingly!
 *
 * For more information, review the prop interface and documentation for both
 * the `InputField` and the `NumberInput`.
 */
const NumberField = /*#__PURE__*/React.forwardRef(({
  disabled = false,
  InputProps,
  max,
  min,
  mode = 'number',
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.InputField, _extends({
  after: (0, _pragma.createFelaElement)(_.View, {
    css: css.maxValue
  }, (0, _pragma.createFelaElement)(_.Text, {
    "aria-label": "Maximum: ".concat(max),
    children: max,
    color: disabled ? 'disabled.3' : undefined,
    variant: "meta"
  })),
  before: (0, _pragma.createFelaElement)(_.View, {
    css: css.minValue
  }, (0, _pragma.createFelaElement)(_.Text, {
    "aria-label": "Minimum: ".concat(min),
    children: min,
    color: disabled ? 'disabled.3' : undefined,
    variant: "meta"
  })),
  disabled: disabled,
  InputProps: { ...InputProps,
    as: _.NumberInput,
    css: css.input,
    mode
  }
}, otherProps, {
  showValidationIcons: false,
  ref: ref
})));
NumberField.displayName = 'NumberField';
var _default = NumberField;
exports.default = _default;
//# sourceMappingURL=NumberField.js.map